import { Injectable, PLATFORM_ID, Inject } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { Observable, of, switchMap, catchError } from "rxjs";
import { LoggingService } from "../services/logging.service";

@Injectable({
  providedIn: "root",
})
export class SjGuard implements CanActivate {
  constructor(
    private router: Router,
    private loggingService: LoggingService,
    private authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // localStorage is not available during SSR — skip the check on the server
    // to prevent a crash that would break Angular's bootstrap on the client.
    if (!isPlatformBrowser(this.platformId)) {
      return of(true);
    }

    const anonymousId = localStorage.getItem("anonymousId");
    return this.authService.getUid$("RequestUserService").pipe(
      switchMap((userId) => {
        if (!userId && !anonymousId) {
          if (state?.url?.search("prosub_id") > -1) {
            const params = route.queryParams;
            return of(this.router.createUrlTree(["partial-registration"], { queryParams: params }));
          } else {
            return of(this.router.createUrlTree(["partial-registration"]));
          }
        }
        return of(true);
      }),
      catchError((error) => {
        this.loggingService.logError("SjGuard error", error);
        // Return a UrlTree redirect so SSR always emits valid HTML with app-root
        return of(this.router.createUrlTree(["partial-registration"]));
      })
    );
  }
}
